












import { Component, Vue } from "vue-property-decorator";
import TaskTypeList from "../templates/TaskTypeList.vue";
import Action from "../models/action";
import TaskType from "../entities/task-type";
import TaskTypeEditModal from "./TaskTypeEditModal.vue";
import TaskTypeNewModal from "./TaskTypeNewModal.vue";

@Component({
  components: {
    TaskTypeList,
    TaskTypeNewModal,
    TaskTypeEditModal
  }
})
export default class TaskTypePage extends Vue {
  get actions(): Action[] {
    return [
      new Action({
        key: "new",
        text: "新規登録",
        variant: "default",
        click: () => {
          this.newTaskType();
        }
      })
    ];
  }

  get tasktypes() {
    return this.$store.getters["tasktype/all"];
  }

  newTaskType() {
    (this.$refs.newModal as any).show();
  }

  editTaskType(t: TaskType) {
    (this.$refs.editModal as any).show(t.id);
  }

  sort(tasktypes: TaskType) {
    this.$store.dispatch("tasktype/sort", tasktypes);
  }

  private created() {
    this.$store.dispatch("tasktype/init");
  }
}
